/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-watch-timer',
  standalone: true,
  imports: [],
  templateUrl: './watch-timer.component.html',
  styleUrl: './watch-timer.component.scss',
})
export class WatchTimerComponent implements OnInit, OnDestroy {
  startDateUTC = input.required<string>();
  timerSubscription: Subscription | undefined;
  displayTime: string = '00:00';

  private startDate: Date | undefined;

  ngOnInit(): void {
    if (this.startDateUTC()) {
      this.startDate = new Date(this.startDateUTC());
      this.startTimer();
    }
  }
  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  startTimer() {
    this.updateTimer();
    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateTimer();
    });
  }

  updateTimer(): void {
    const currentTime = new Date();
    const elapsedTime = new Date(currentTime.getTime() - this.startDate!.getTime());
    const hours = Math.floor(elapsedTime.getTime() / (1000 * 60 * 60));
    const minutes = elapsedTime.getUTCMinutes();
    const seconds = elapsedTime.getUTCSeconds();

    this.displayTime = this.formatTime(hours, minutes, seconds);
  }

  formatTime(hours: number, minutes: number, seconds: number): string {
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');
    return hoursStr !== '00'
      ? `${hoursStr}:${minutesStr}:${secondsStr}`
      : `${minutesStr}:${secondsStr}`;
  }
}
